/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Status_505Inputs */

const vi_carrier_status_505 = /** @type {(inputs: Carrier_Status_505Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yêu cầu chuyển hoàn`)
};

/**

* @param {Carrier_Status_505Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_status_505 = /** @type {((inputs?: Carrier_Status_505Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Status_505Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_status_505(inputs)
});